import { createGridLayout, createGridItem } from "../../store/global/gridlayout";

export const modulePluginsGrid = createGridLayout({
  margin: [12, 4],
  layout: [
    createGridItem({
      x: 0,
      y: 0,
      w: 30,
      h: 40,
      i: "Active Plugins"
    }),
    createGridItem({
      x: 30,
      y: 0,
      w: 30,
      h: 40,
      i: "Available Plugins"
    })
  ]
});
